import { Pagination } from "@/components/pagination/pagination";
import { RowData } from "@tanstack/react-table";
import { RowWithIdentifier } from "../_helpers/row-identifier";
import { DataTableInstance } from "../types";

export interface DataTablePaginationProps<TData extends RowData & RowWithIdentifier> {
  table: DataTableInstance<TData>;
  itemsCount: number;
  isLoading?: boolean;
}

export function DataTablePagination<TData extends RowData & RowWithIdentifier>({
  table,
  itemsCount,
  isLoading,
}: DataTablePaginationProps<TData>) {
  const { pageIndex, pageSize } = table.state.pagination;
  const rawLastPage = Math.ceil(itemsCount / pageSize);
  const lastPage = Math.max(rawLastPage, 1);
  const currentPage = Math.max(1, Math.min(pageIndex + 1, lastPage));

  return (
    <Pagination
      currentPage={currentPage}
      lastPage={lastPage}
      canGoPrevious={table.getCanPreviousPage()}
      canGoNext={table.getCanNextPage()}
      onFirstPage={() => table.firstPage()}
      onPreviousPage={() => table.previousPage()}
      onNextPage={() => table.nextPage()}
      onLastPage={() => table.lastPage()}
      onGoToPage={(page) => table.setPageIndex(page - 1)}
      isLoading={isLoading}
    />
  );
}
